import { render } from "./PaymentModal.vue?vue&type=template&id=63b08860&scoped=true"
import script from "./PaymentModal.vue?vue&type=script&lang=js"
export * from "./PaymentModal.vue?vue&type=script&lang=js"

import "./PaymentModal.vue?vue&type=style&index=0&id=63b08860&lang=scss&scoped=true"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63b08860"]])

export default __exports__